import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';

export interface ShareRequest {
  resource_type: string;
  resource_id: string;
  shared_with_type: string;
  shared_with_id: string;
  permission: string;
}

export interface ShareResponse {
  id: string;
  resource_type: string;
  resource_id: string;
  shared_with_type: string;
  shared_with_id: string;
  permission: string;
  created_at: string;
  updated_at: string;
}

@Injectable({
  providedIn: 'root'
})
export class SharingService {
  private baseUrl: string = environment.baseUrl;

  constructor(private http: HttpClient, private userService: UserService) {}

  public shareResource(shareData: ShareRequest): Observable<ShareResponse> {
    const endpoint = `${this.baseUrl}/shares`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.userService.currentAccessToken}`
    });
    return this.http.post<ShareResponse>(endpoint, shareData, { headers });
  }

  public getSharesForResource(
    resourceType: string,
    resourceId: string
  ): Observable<ShareResponse[]> {
    const endpoint = `${this.baseUrl}/shares/${resourceType}/${resourceId}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.userService.currentAccessToken}`
    });
    return this.http.get<ShareResponse[]>(endpoint, { headers });
  }

  public updateSharePermission(
    shareId: string,
    permissions: any
  ): Observable<ShareResponse> {
    const endpoint = `${this.baseUrl}/shares/${shareId}`;
    return this.http.put<ShareResponse>(endpoint, { permissions });
  }

  public deleteShare(shareId: string): Observable<any> {
    const endpoint = `${this.baseUrl}/shares/${shareId}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.userService.currentAccessToken}`
    });
    return this.http.delete(endpoint, { headers });
  }

  public checkAccess(
    resourceType: string,
    resourceId: string,
    permission: string = 'read'
  ): Observable<{ has_access: boolean }> {
    const endpoint = `${this.baseUrl}/shares/check-access/${resourceType}/${resourceId}?permission=${permission}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.userService.currentAccessToken}`
    });
    return this.http.get<{ has_access: boolean }>(endpoint, { headers });
  }
}
